import { Link } from 'react-router-dom'
import useAuth from '../hooks/useAuth'
function UserNav({ active = 'profile', userId }) {
  const { auth } = useAuth();
  const isGp = auth?.user?.type_id === 4 && auth?.user?.company_id === 9
  
  return (
    <div className="bg-white rounded-md shadow-md py-3 px-4 mb-8">
      <ul className="flex flex-col md:flex-row flex-wrap list-none px-0">
        <Link to={`/users/${userId}`}>
          <li className={`tab-btn ${active === 'profile' ? 'active' : ''}`}>
            Profile
          </li>
        </Link>
        {!isGp && (
          <>
            <Link to={`/users/${userId}/clients`}>
              <li className={`tab-btn ${active === 'clients' ? 'active' : ''}`}>
                Clients
              </li>
            </Link>
            <Link to={`/users/${userId}/specialities`}>
              <li
                className={`tab-btn ${active === 'specialities' ? 'active' : ''}`}
              >
                Specialities
              </li>
            </Link>
        </>
        )}
        <Link to={`/users/${userId}/account-settings`}>
          <li
            className={`tab-btn ${
              active === 'account-settings' ? 'active' : ''
            }`}
          >
            Account Settings
          </li>
        </Link>
        <Link to={`/users/${userId}/bookings`}>
          <li className={`tab-btn ${active === 'bookings' ? 'active' : ''}`}>
            Bookings
          </li>
        </Link>
        <Link to={`/users/${userId}/availability`}>
          <li
            className={`tab-btn ${active === 'availability' ? 'active' : ''}`}
          >
            Availability
          </li>
        </Link>
      </ul>
    </div>
  )
}

export default UserNav
